const data: string = "<div class=\"feeplan-section\"><acp-feeplan-base-component></acp-feeplan-base-component></div>";
export default data